import { render } from "./RatingP2P.vue?vue&type=template&id=0ef1073a"
import script from "./RatingP2P.vue?vue&type=script&lang=js"
export * from "./RatingP2P.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__